/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ReminderOptions from './reminder-options';
import ReminderOptionsDetail from './reminder-options-detail';
import ReminderOptionsUpdate from './reminder-options-update';
import ReminderOptionsDeleteDialog from './reminder-options-delete-dialog';

const ReminderOptionsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ReminderOptions />} />
    <Route path="new" element={<ReminderOptionsUpdate />} />
    <Route path=":id">
      <Route index element={<ReminderOptionsDetail />} />
      <Route path="edit" element={<ReminderOptionsUpdate />} />
      <Route path="delete" element={<ReminderOptionsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ReminderOptionsRoutes;
